export const SPOTLIGHT_ONBOARDING_TARGET = 'rovo-chat-button';
